
<div class="card">
    <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center justify-content-start">
                <div class="ms-2">
                    <h4 class="me-1">
                        {{"OTP" | translate }}
                    </h4>

                </div>
            </div>
           
        </div>
    </div>


    <div class="card-body" style="max-height:550px">



        <p class="a-o-i">{{'Enter_Valid_OTP' | translate }}</p>

        <div class="otp-class">

            <div class="d-flex align-items-center">
                <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>
            </div>

            <br />

            <!-- Buttons -->
            <div class="otp-actions">
                <button class="btn-primary" (click)="onSubmit()">
                    {{ 'Continue' | translate }}
                </button>
                <button class="btn-warn" (click)="dialogRef.close()">
                    {{ 'Cancel' | translate }}
                </button>
            </div>

        </div>

        




        


    </div>
</div>




